import { convertLegacyColor } from '../../color-conversion';
import {
	getLightnessPercentage,
	increaseLightness,
	reduceLightness,
} from '../../color-utils/lightness-utils';
import { getBackgroundHoveredColor } from '../../use-built-in-color-map';

const DARK_THRESHOLD = 50;

const convertToHoveredShade = (hexColor: string) => {
	const lightnessPercentage = getLightnessPercentage(hexColor);
	if (lightnessPercentage === undefined) {
		return hexColor;
	}

	// Lighten dark colors; darken light colors slightly based on LCH lightness
	// 0 - 100 dark to light
	const LIGHTEN_TO = Math.min(100, Math.round(lightnessPercentage + 10));
	const DARKEN_TO = Math.max(0, Math.round(lightnessPercentage - 10));

	if (lightnessPercentage < DARK_THRESHOLD) {
		return increaseLightness(hexColor, LIGHTEN_TO);
	}
	return reduceLightness(hexColor, DARKEN_TO);
};

export const computeHoveredBackgroundColor = (backgroundColor: string) => {
	const tokenizedHoveredBackgroundColor = getBackgroundHoveredColor(backgroundColor);
	if (tokenizedHoveredBackgroundColor) {
		return tokenizedHoveredBackgroundColor;
	}

	const convertedColor = convertLegacyColor(backgroundColor);
	if (convertedColor.isValid()) {
		return convertToHoveredShade(convertedColor.toHexString());
	}

	return backgroundColor;
};
